import cn from 'classnames';
import styles from './hamburger.module.scss';

export interface IHamburgerProps {
  isActive: boolean;
  onClick: () => void;
  className?: string;
}

const Hamburger = ({
  isActive,
  onClick,
  className = '',
}: IHamburgerProps): JSX.Element => {
  const classNames = cn(styles.hamburger, className, {
    [styles.open]: isActive,
  });

  return (
    <button type="button" className={classNames} onClick={onClick}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
};

export default Hamburger;
